import { CustomState } from "@hardware/Store/Reducers";
import setFieldValue from "@hardware/Store/State/CreateAccount/SetFieldValue";
import { CreateAccountFormContext } from "@hardware/Widgets/CreateAccount/CreateAccountForm";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: CustomState) => ({
    message: state.createAccountForm.fieldValues["message"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface MessageStyles {
    messageTextArea?: TextAreaProps;
}

export const messageStyles: MessageStyles = {};

const styles = messageStyles;

const Message: React.FC<Props> = ({ fields, message, setFieldValue }) => {
    const { label, hintText, isRequired } = fields;
    const createAccountFormContext = React.useContext(CreateAccountFormContext);
    const [messageErrorMessage, setMessageErrorMessage] = React.useState("");

    React.useEffect(() => {
        createAccountFormContext.validators.message = validateMessage;
        if (typeof message !== "undefined") {
            validateMessage();
        }
    }, [message]);

    React.useEffect(() => {
        createAccountFormContext.validators.message = validateMessage;
    }, [isRequired]);

    const validateMessage = () => {
        const errorMessage = isRequired && !message ? (siteMessage("Field_Required", label) as string) : "";
        setMessageErrorMessage(errorMessage);
        return !errorMessage;
    };

    const messageChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setFieldValue({ key: "message", value: event.target.value });
    };

    return (
        <TextArea
            {...styles.messageTextArea}
            label={label}
            required={isRequired}
            placeholder={hintText}
            value={message || ""}
            error={messageErrorMessage}
            onChange={messageChangeHandler}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(Message),
    definition: {
        group: "Create Account" as any,
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Message",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "How can I help you?",
                isRequired: true,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
